import { Separator, Text, TextProps } from "@nju/ui";
import { formatPrice } from "@nju/utils";

interface IPackagePriceProps {
  align: TextProps["align"];
  amount: number | undefined;
  refillPeriod: number | undefined;
}

export function PackagePrice({
  align,
  amount,
  refillPeriod,
}: IPackagePriceProps) {
  return (
    <Text
      align={align}
      display="block"
      size={{
        "@fromTablet": "xl",
      }}
      tone="accent"
      weight="bold"
    >
      {refillPeriod && <>pakiet na {refillPeriod} dni</>}
      <Separator size="none" tone="invisible" />
      {amount && <>{formatPrice(amount)} zł</>}
      {!amount && <> zł</>}
    </Text>
  );
}
